import { PB_URL } from "../lib/pocketbase";

// Thumb sizes generated by PocketBase (must be listed on the `images` field).
// Photos are square; "f" fits the whole image instead of cropping to the box,
// so pendants at the edge of a necklace shot are not cut off.
export const THUMB = {
  tiny: "100x100", // cart rows, search results
  grid: "400x400f", // product cards
  detail: "1000x1000f", // product detail gallery
};

const fileUrl = (record, filename, thumb) =>
  `${PB_URL}/api/files/${record.collectionId}/${record.id}/${filename}` +
  (thumb ? `?thumb=${thumb}` : "");

// PocketBase record -> the shape the components consume.
export const mapProduct = (record) => ({
  id: record.id, // PocketBase id (string) is now the identity
  sku: record.sku,
  name: record.name,
  price: record.price,
  gender: record.gender, // was `category` when the catalog was hardcoded
  subcategory: record.subcategory,
  metal: record.metal,
  stone: record.stone,
  description: record.description,
  // drop blank bullets so an empty entry never renders as a dot
  features: (record.features || [])
    .map((f) => String(f).trim())
    .filter(Boolean),
  // [{ size, qty }] — structured, no longer regex-scraped from `features`
  sizes: (record.sizes || []).map((s) => ({
    size: String(s.size),
    qty: Number(s.qty) || 0,
  })),
  images: (record.images || []).map((f) => fileUrl(record, f, THUMB.detail)),
  thumbs: (record.images || []).map((f) => fileUrl(record, f, THUMB.grid)),
  tinyThumbs: (record.images || []).map((f) => fileUrl(record, f, THUMB.tiny)),
  rating: record.rating || 0,
  reviews: record.reviews || 0,
  // Sold out when deactivated, or when every size is down to 0 — the dashboard
  // can leave `active` on while the stock is gone.
  outOfStock:
    !record.active ||
    ((record.sizes || []).length > 0 &&
      record.sizes.every((s) => !(Number(s.qty) > 0))),
  updated: record.updated || "",
  sortOrder: record.sortOrder ?? 0,
});
